import styled from "styled-components";
import grain from "./../../assets/images/grain.svg";
import Lottie from "lottie-react";
import { images as imageValues } from "../../imageValues";
import { auto } from "@popperjs/core";

export const Container = styled.div`
  background-color: #463048;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-size: cover;
  background-repeat: no-repeat;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 380px;
`;

export const ContainerTwo = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  /* background-color: pink; */
`;

export const GamePad = styled.div`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1px;
  background-color: #d09400;
`;

export const Box = styled.div`
  height: 46px;
  width: 46px;
  background-color: #f8c933;
  background-image: url(${grain});
  background-blend-mode: multiply;
`;

export const MatchBoxStrip = styled.img`
  width: 100%;
  height: 20px;
`;

export const CenterArea = styled.div`
  background-color: #463048;
  width: 380px;
  height: 500px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Header = styled.span`
  display: flex;
  color: #f8c933;
  font-size: 30px;
  letter-spacing: 1px;
`;

export const BottomView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: flex;
  width: 100%;
`;

export const BottomText = styled.span`
  color: #f8c933;
  padding-right: 10px;
  font-size: 14px;
  background-image: url(${imageValues.BULB});
  background-repeat: no-repeat;
  background-size: 28px;
  background-position: center;
`;

export const BottomTextTwo = styled.span`
  color: #f8c933;
  padding-right: 10px;
  font-size: 14px;
  /* background-image: url(${imageValues.BULB}); */
  /* background-repeat: no-repeat; */
  background-size: 28px;
  background-position: center;
`;

export const IButtonLinkArea = styled.span`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

export const IButton = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  background-color: transparent;
  background: none;
  border: none;
  top: 1.75px;
  cursor: pointer;
`;

export const DiceButton = styled.button`
  margin: 10px 5px 10px 10px;
  background: none;
  background-color: orange;
  background-image: url(${grain});
  background-blend-mode: multiply;
  border: none;
  :active {
    transform: translateY(1px);
  }
  cursor: pointer;
  -webkit-animation: throb 1.5s infinite ease-in-out;
  animation: ${(props) =>
    props.showAnimation ? "glow 1.5s infinite ease-in-out" : ""};

  @-webkit-keyframes glow {
    0% {
      -webkit-box-shadow: 0 0 0px 50px rgba(256, 256, 256, 0.9);
    }
    50% {
      -webkit-box-shadow: 0 0 0px 0px rgba(256, 256, 256, 0.2);
    }
    100% {
      -webkit-box-shadow: 0 0 0px 50px rgba(256, 256, 256, 0.9);
    }
  }
  @keyframes glow {
    0% {
      box-shadow: 0 0 20px rgba(256, 256, 256, 0.9);
    }
    50% {
      box-shadow: 0 0 20px rgba(256, 256, 256, 0.2);
    }
    100% {
      box-shadow: 0 0 20px rgba(256, 256, 256, 0.9);
    }
  }
`;

export const KaudiImage = styled.img`
  height: 72px;
  width: 72px;
`;

export const CollectionImage = styled.div`
  background-color: transparent;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 100%;
  height: 100%;
`;

export const Room = styled.div`
  width: 320px;
  height: 195px;
`;
export const RoomParentDiv = styled.div`
  position: relative;
  margin: 8px;
`;

export const RoomImage = styled.img`
  width: 320px;
  z-index: 1;
  top: 0;
`;

export const TutorialContentArea = styled.div`
  background-color: #463048;
  background-image: url(${grain});
  background-blend-mode: multiply;
  color: white;
  text-align: center;
  font-weight: 600;
  padding: 15px 75px 15px 75px;
`;

export const TransparentBackground = styled.div`
  width: 380px;
  background-color: rgba(0, 0, 0, 0.85);
  position: absolute;
  height: 100%;
`;

export const ShowMessageSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const RoomCollectionImage = styled.img`
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  position: absolute;
  height: auto;
  width: 28px;
  /* mix-blend-mode: exclusion; */
  animation: ${(props) =>
    props.show ? "" : `add-to-room 1s ease-in-out ${props.index * 0.5}s`};
  @keyframes add-to-room {
    0% {
      transform: translate(0%, 0%) scale(2);
    }
  }
`;

export const LottieAnimation = styled(Lottie)`
  height: 100px;
  width: 100px;
  display: ${(props) => (props.info ? "none" : "")};
`;

export const BazaarName = styled.div`
  font-size: 10.6px;
  color: rgb(153 40 40);
  font-weight: 800;
`;

export const TutorialContentArea2 = styled.div`
  background-color: #463048;
  /* background-image: url(${grain}); */
  background-blend-mode: multiply;
  padding: 10px;
  border-radius: 50px;
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 30px;
  font-size: 12.5px;
  font-weight: 600;
  width: 70%;
  position: relative;
  text-align: center;

  /* margin-left: 400px; */
  &:before {
    content: "";
    width: 0px;
    height: 0px;
    background-image: url(${grain});
    position: absolute;
    border-left: 22px solid #463048;
    border-right: 0px solid transparent;
    border-top: 14px solid #463048;
    /* border-bottom: 5px solid transparent; */

    border-bottom-left-radius: 13px;
    transform: rotate(270deg);
    left: 180px;
    bottom: -12px;
  }
`;

export const MatchBoxStripArea = styled.span`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

export const MatchBoxStripButton = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  background-color: transparent;
  background: none;
  border: none;
  top: 1.75px;
  cursor: pointer;
  width: 30px;
  height: 38px;
`;

export const BottomTextArea = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  width: 100%;
  height: 70px;
  justify-content: center;
`;

export const CollectionArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Buttons = styled.button`
  background-color: #463048;
  /* background-image: url(${grain});
  background-blend-mode: multiply; */
  height: 34px;
  width: 34px;
  border: none;
  justify-content: center;
  align-items: center;
  display: flex;
  :active {
    transform: translateY(1px);
  }
  cursor: pointer;
  margin-right: 1.5px;
`;

export const ModalButton = styled.button`
  cursor: pointer;
  :active {
    transform: translateY(1px);
  }
  font-size: 14px;
`;

export const Door = styled.img`
  position: absolute;
  height: 50px;
  width: 50px;
  left: 0px;
`;
export const ImageStyle = styled.img`
  height: auto;
  width: 24px;
  margin-top: 48px;
  margin-left: 138px;
`;
export const P = styled.p`
  color: #f8c933;
  /* font-size: 20px; */
  font-size: ${(props) => (props.isEnglish === true ? "20px" : "18px")};
  font-weight: bold;
  text-align: center;
  margin-bottom: -5px;
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 20px;
  margin-left: 20px;
  /* margin-top: 30px; */
`;
export const Para = styled.p`
  font-size: 10px;
  color: white;
  text-align: center;
  padding-left: ${(props) => (props.isEnglish ? '20px' : '30px')};
  padding-right: ${(props) => (props.isEnglish ? '20px' : '30px')};
`;
export const Div = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  position: absolute;
  bottom: 242px;
`;
export const TextDiv = styled.div`
  position: absolute;
  flex: 1;
  bottom: 100px;
  text-align: center;
  font-size: 11px;
  color: #fff;
  padding-left: 50px;
  padding-right: 50px;
  text-decoration: underline;
`;
export const ContainerDiv = styled.div`
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MarketDiv = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const Button = styled.button`
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`;
export const ButtonImg = styled.img`
  width: 30px;
  height: 30px;
`;
export const OuterDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 380px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
